import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { CallServiceAbstract } from "../call.service";
import { SettingsService } from "../../settings.service";
import { AuthenticationService } from "../../auth/Authentication/authentication.service";
import { Subject } from "rxjs";
import { NotificationService } from "../../notification.service";
import { StateService } from "../../state/state.service";

@Injectable({
  providedIn: "root",
})
export class ProductionTechnologiesRecipes extends CallServiceAbstract {
  constructor(
    http: HttpClient,
    settings: SettingsService,
    authentication: AuthenticationService,
    notify: NotificationService,
    state: StateService
  ) {
    super(
      http,
      settings,
      authentication,
      notify,
      state,
      "Production_Technologies_Recipes",
      "Технологии"
    );
  }

  public predefineState(state) {
    state = super.predefineState(state);
    state.expand.push("Store($select=Id,Name)");
    state.expand.push(
      "Product($select=Id,Name,StandardCostPerLot,PartNumber,ProductType,CustomProperty_CheckAvailableQty,CustomProperty_StoreForProdOrder;$expand=MeasurementUnit($select=Code),ProductType,ProductGroup($select=CustomProperty_PRODUCTIONAPP_SKIP))"
    );
    state.expand.push("Operations");
    state.expand.push(
      "Ingredients($expand=Material($select=Id,StandardCostPerLot,Name,PartNumber,CustomProperty_CheckAvailableQty,ProductType,CustomProperty_StoreForProdOrder;$expand=MeasurementUnit($select=Code),Dimensions($expand=DestQuantityUnit($select=Code),SourceQuantityUnit($select=Code)),ProductType,ProductGroup($select=CustomProperty_PRODUCTIONAPP_SKIP)),Store($select=Id,Name),UsageUnit($select=Code))"
    );
    return state;
  }

  filterRecipeies(filter) {
    let obz = new Subject();
    this.query(filter).subscribe(
      (data) => obz.next(data),
      (err) => obz.error(err)
    );
    return obz.asObservable();
  }
}
